import styled from 'styled-components';

export const DiaryStudyProvideStyles = styled.div`
  padding: 70px 0;
  display: flex;
  flex-direction: column;
  gap: 50px;

  @media (max-width: 991px) {
    gap: 25px;
    padding: 40x 0;
  }

  .cards {
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: space-around;
    flex-wrap: wrap;
    gap: 25px;

    &-item {
      display: flex;
      flex-direction: column;
      gap: 24px;
      max-width: 370px;
      width: 100%;

      @media (max-width: 991px) {
        gap: 18px;
      }

      img {
        max-width: 38px;
      }

      h6 {
        font-weight: 600;
        font-size: 22px;
        line-height: 125%;
        color: #0f0e0c;
        margin: 0;
      }

      p {
        font-weight: 400;
        font-size: 16px;
        line-height: 125%;
        color: #0f0e0c;
        margin: 0;
      }
    }
  }
`;
